import { Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, message, Row, Slider } from 'antd'
import { VoucherMultiOrders } from 'components/Purchasing/Voucher/VoucherMultiOrders'
import useFetch from 'elements/Hooks/useFetch'
import CentersCascader from '../../../elements/Cascader/CentersCascader'
import CustomModalButton from '../../../elements/CustomModalButton'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import useFetchSelect from '../../../elements/Hooks/useFetchSelect'
import InfoTooltip from '../../../elements/InfoTooltip'
import Currency from '../../../elements/Select/Currency'
import CustomDebounceSelect from '../../../elements/Select/CustomDebounceSelect'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import { get, isEmpty, round, sum } from 'lodash'
import { boolLabelItemLayout, defaultFormItemLayout, fullWidthFormItemLayout, rules } from 'modules/FormItems'
import { dateVal, findCascadersParents, numVal, strVal } from 'modules/Utils'
import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import Taxes from '../../../elements/Taxes'

const { TextArea } = Input

function VouchersForm(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form
  const { voucher, modalType, requisition, isConfirmed, isNew, lines, fetchingLines } = props
  const { data: centers } = useFetch({ url: `/centers/?select=*` })

  const isEdit = modalType === 'edit'
  const type = getFieldValue('type') || get(voucher, 'type')
  const isClaimTypeCreditCard = type === 'Credit Card' || voucher?.type === 'Credit Card'
  const isCreditCard = isEmpty(getFieldValue('isCreditCard')) ? getFieldValue('isCreditCard') : voucher?.isCreditCard
  const iswtax = getFieldValue('wtax.applicable') || get(voucher, 'wtax.applicable')
  const isAccountTransfer = type === 'Account Transfer'
  const isBankTransfer = type === 'Bank Transfer'
  const isCreditNote = type === 'Credit Note'
  const isTaxInvoiceORCreditNoteOrNonTaxInvoice = [
    'Non Tax Invoice',
    'Credit Note',
    'Tax Invoice',
    'Credit Card',
  ].includes(type)
  const isTransfer = ['Account Transfer', 'Bank Transfer'].includes(type)
  const isRequestFund = type === 'Funds Request'

  let vendor = (getFieldValue('payee._id') || get(voucher, 'payee._id') || '').replace('members/', '')

  let company = (getFieldValue('company._id') || get(voucher, 'company._id') || '').replace('members/', '')

  let orders = getFieldValue('orders') || get(voucher, 'orders') || []

  let lenderContractID = getFieldValue('lenderContract._id') || get(voucher, 'lenderContract._id')
  let lenderContractKey = lenderContractID && lenderContractID.replace('lenderContracts/', '')

  let statementID = getFieldValue('statement._id') || get(voucher, 'statement._id')
  let statementKey = statementID && statementID.replace('statements/', '')

  const { SelectData: VendorBanksSelect } = useFetchSelect({
    url: `clients/${isClaimTypeCreditCard ? company : vendor}/member/banks/`,
    dependencyArray: [isClaimTypeCreditCard ? company : vendor],
    dontFetch: isEmpty(isClaimTypeCreditCard ? company : vendor),
  })

  const { SelectData: CorporateBanksSelect } = useFetchSelect({
    url: `clients/${company}/member/banks/`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
  })

  const { SelectData: VendorRepSelect } = useFetchSelect({
    url: `members/${vendor}/representatives`,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
  })

  const { SelectData: LenderContractsSelect } = useFetchSelect({
    url: `lenderContracts?select=_id,title`,
  })

  const { SelectData: PayPlanSelect } = useFetchSelect({
    url: `statements/${statementKey}/payplan/`,
    dontFetch: isEmpty(lenderContractKey) || !isClaimTypeCreditCard,
    dependencyArray: [lenderContractKey],
    mapFunction: (c) => ({
      ...c,
      display: `${c.name} ${c.date && dateVal(c, 'date').format('DD-MMM-YY')} ${c.amount} ${c.currency}`,
    }),
  })

  const { SelectData: FileSelectCmp } = useFetchSelect({
    url: `files/?folder=${voucher._id}`,
    dependencyArray: [voucher],
    dontFetch: isEmpty(voucher._id),
  })

  const { SelectData: StatementSelect, selected: statement } = useFetchSelect({
    url: `statements/?select=*&status=Approved&member=members/${vendor}&paid=false&registered=false`,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
    mapFunction: (c) => ({
      ...c,
      display: `[${c.code}]  ${c.no} - ${c.bank.title} - ${c.company.fn}`,
      _id: c._id,
    }),
  })

  const { SelectData: LendersSelect } = useFetchSelect({ url: 'lenders/' })
  const { SelectData: OrganisationsSelect } = useFetchSelect({ url: 'corporates/' })
  const { SelectData: InvoiceSelect, selected: invoice = {} } = useFetchSelect({
    url: 'invoices?select=*&type=Funds Request',
  })

  const { SelectData: LendersContractSelect } = useFetchSelect({
    url: `lenders/contracts/${company}?type=interCompany`,
    dontFetch: isEmpty(company),
    dependencyArray: [company],
  })

  ///////////

  const [vPercent, setVPercent] = useState(get(voucher, 'vPercent') || 30)

  const [vPercent_Total, setVPercent_Total] = useState(0)
  const [vPercent_Amount, setVPercent_Amount] = useState(0)

  useEffect(() => {
    if (vPercent_Total === 0) {
      const total = round(
        sum(lines.filter((l) => l.isNonPayAndLoss !== true).map((d) => numVal(d, 'amount.gross'))) *
          get(voucher, 'vPercent', 100) *
          0.01,
        2
      )
      setVPercent_Total(total)
      setVPercent_Amount(total)
    }
  }, [lines, fetchingLines])

  useEffect(() => {
    if (vPercent !== getFieldValue('vPercent')) {
      setFieldsValue({
        vPercent: typeof vPercent === 'number' ? vPercent : 0,
      })
    }
  }, [vPercent])

  useEffect(() => {
    if (!isEmpty(statement)) {
      const company = strVal(statement, 'company._id') || getFieldValue('company._id')
      const multiCenter = centers.filter((i) => i.name === 'Multi Center').find((i) => i.company._id === company) || {}

      setFieldsValue({
        scheduledDate: dateVal(statement, 'due') || getFieldValue('scheduledDate'),
        currency: strVal(statement, 'bank.bank.currency') || getFieldValue('currency'),
        'company._id': company,
        'bank._id': strVal(statement, 'bank.bank.bank') || getFieldValue('bank._id'),
        billDate: dateVal(statement, 'period.end') || getFieldValue('billDate'),
        dueDate: dateVal(statement, 'due') || getFieldValue('dueDate'),
        no: strVal(statement, 'no') || getFieldValue('no'),
        centers: strVal(multiCenter, '_id') ? findCascadersParents(centers, multiCenter._id) : [],
        'lenderContract._id': strVal(statement, 'bank._id') || getFieldValue('lenderContract._id'),
      })
    }
  }, [statement, centers])

  useEffect(() => {
    if (!isEmpty(invoice)) {
      setFieldsValue({
        currency: strVal(invoice, 'currency') || getFieldValue('currency'),
        'bank._id': strVal(invoice, 'bank.bank.bank') || getFieldValue('bank._id') || get(voucher, 'bank._id'),
        centers: findCascadersParents(centers, strVal(invoice, 'center._id')),
        'notify.main._id': strVal(invoice, 'companyRep._id') || getFieldValue('notify.main._id'),
      })
    }
  }, [invoice._id])

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Voucher Type">
            {getFieldDecorator('type', {
              initialValue: get(voucher, 'type'),
              rules: [{ required: true, message: 'Please Select a Claim Type!' }],
            })(<TypeSelect style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        {isTaxInvoiceORCreditNoteOrNonTaxInvoice && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Claim No">
              {getFieldDecorator('no', {
                initialValue: get(voucher, 'no'),
                rules: [{ required: true, message: 'Please use the Invoice No!' }],
              })(<Input disabled={isConfirmed} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        )}
      </Row>

      {isTransfer ? (
        // IS TRANSFER (Account / Bank / Inter company)
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Transfer From">
              {getFieldDecorator('company._id', {
                initialValue: get(voucher, 'company._id') || get(requisition, 'company._id'),
              })(
                <OrganisationsSelect
                  keyAtr={'_id'}
                  valueAtr={'fn'}
                  disabled={isConfirmed}
                  onChange={(value) => (isAccountTransfer || isBankTransfer) && setFieldsValue({ 'payee._id': value })}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Transfer To">
              {getFieldDecorator('payee._id', {
                initialValue: get(voucher, 'payee._id'),
                rules: [{ required: true, message: 'Please Select a Transferee!' }],
              })(
                <OrganisationsSelect
                  keyAtr={'_id'}
                  valueAtr={'fn'}
                  disabled={isConfirmed}
                  onChange={(value) =>
                    (isAccountTransfer || isBankTransfer) && setFieldsValue({ 'company._id': value })
                  }
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="From Account">
              {getFieldDecorator('fromBank._id', {
                initialValue: get(voucher, 'fromBank._id'),
                rules: [{ required: true, message: 'Please Select a the Transfer From Account' }],
              })(
                <CorporateBanksSelect
                  keyAtr={'_id'}
                  valueAtr={'nickname'}
                  placeholder="Select a bank"
                  onChange={(value) => isAccountTransfer && setFieldsValue({ 'bank._id': value })}
                  disabled={!getFieldValue('company._id') || isConfirmed}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="To Account">
              {getFieldDecorator('bank._id', {
                initialValue: get(voucher, 'bank._id'),
                rules: [{ required: true, message: 'Please Select the Transfer To Account' }],
              })(
                <VendorBanksSelect
                  keyAtr={'_id'}
                  valueAtr={'nickname'}
                  placeholder="Select a bank"
                  disabled={!getFieldValue('payee._id') || isConfirmed}
                  onChange={(value) => isAccountTransfer && setFieldsValue({ 'fromBank._id': value })}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="From Currency">
              {getFieldDecorator('fromBank.currency', {
                initialValue: get(voucher, 'fromBank.currency') || get(requisition, 'fromBank.currency'),
                rules: [{ required: true, message: 'Please Select a Currency!' }],
              })(<Currency disabled={isConfirmed} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="To Currency">
              {getFieldDecorator('currency', {
                initialValue: get(voucher, 'currency') || get(requisition, 'currency'),
                rules: [{ required: true, message: 'Please Select a Currency!' }],
              })(<Currency disabled={isConfirmed} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="From Amount">
              {getFieldDecorator('fromBank.amount', {
                initialValue: get(voucher, 'fromBank.amount') || get(requisition, 'fromBank.amount'),
                rules: [{ required: true, message: 'Please Input the Amount!' }],
              })(
                <Input
                  addonBefore={<strong>{getFieldValue('fromBank.currency')}</strong>}
                  disabled={isConfirmed}
                  placestyle={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Claim From">
                {getFieldDecorator('payee._id', {
                  initialValue: get(voucher, 'payee._id'),
                  rules: [
                    {
                      required: true,
                      message: 'Please Select a Payee!',
                    },
                  ],
                })(
                  <VendorSelect
                    keyAtr={'_id'}
                    valueAtr={'fn'}
                    disabled={isEdit || isConfirmed}
                    placeholder="Select a Vendor"
                    style={{ width: '100%' }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...defaultFormItemLayout}
                {...(isAccountTransfer ? { label: 'Transfer From' } : { label: 'Claim To' })}>
                {getFieldDecorator('company._id', {
                  rules: isRequestFund ? rules.select : null,
                  initialValue: get(voucher, 'company._id') || get(requisition, 'company._id'),
                })(
                  isRequestFund ? (
                    <LendersSelect valueAtr={'fn'} keyAtr={'owner'} placeholder={'Select a Company'} />
                  ) : (
                    <OrganisationsSelect keyAtr={'_id'} valueAtr={'fn'} disabled={isConfirmed} />
                  )
                )}
              </Form.Item>
            </Col>
          </Row>
          {isRequestFund && (
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Lender Contract">
                  {getFieldDecorator('lenderContract._id', {
                    initialValue: get(voucher, 'lenderContract._id'),
                    rules: rules.select,
                  })(<LendersContractSelect valueAtr={'title'} placeholder={'Select a Contract'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Request Fund Invoice">
                  {getFieldDecorator('invoice._id', {
                    initialValue: get(voucher, 'invoice._id'),
                    rules: rules.select,
                  })(<InvoiceSelect valueAtr={'title'} placeholder={'Select a Contract'} />)}
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            {!isCreditCard && (
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Claimant Bank">
                  {getFieldDecorator('bank._id', {
                    initialValue: get(voucher, 'bank._id'),
                    rules: [
                      {
                        required: true,
                        message: 'Please Select a Vendor Bank!',
                      },
                    ],
                  })(
                    <VendorBanksSelect
                      keyAtr={'_id'}
                      valueAtr={'nickname'}
                      placeholder="Select a bank"
                      disabled={!getFieldValue('payee._id') || isConfirmed}
                      style={{ width: '100%' }}
                    />
                  )}
                </Form.Item>
              </Col>
            )}
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Currency">
                {getFieldDecorator('currency', {
                  initialValue: get(voucher, 'currency') || get(requisition, 'currency'),
                  rules: [
                    {
                      required: true,
                      message: 'Please Select a Currency!',
                    },
                  ],
                })(<Currency disabled={isConfirmed} />)}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}

      <Row>
        {!isClaimTypeCreditCard && !(isTransfer || isCreditCard || isRequestFund) && (
          <VoucherMultiOrders {...{ vendor, company, voucher, getFieldDecorator, setFieldsValue }} />
          // <Col span={24}>
          //   <Form.Item {...fullWidthFormItemLayout} label="Orders">
          //     {getFieldDecorator('orders', {
          //       initialValue: get(voucher, 'orders') || [get(voucher, 'order._id')],
          //       rules: !isCreditNote ? rules.select : '',
          //     })(
          //       <PurchaseOrderSelect
          //         // style={{ width: '80%' }}
          //         keyAtr={'_id'}
          //         mode="multiple"
          //         valueAtr={'display'}
          //         placeholder="Select a Purchase Order"
          //         // disabled={isEdit || isConfirmed}
          //         // onChange={(value) => {
          //         //   if (value)
          //         //     getPO(value.replace('purchases/', '')).then((data) =>
          //         //       setFieldsValue({
          //         //         'company._id': get(data, 'company._id'),
          //         //         centers: get(data, 'centers'),
          //         //         taxType: get(data, 'taxType'),
          //         //         'tax.type': get(data, 'tax.type'),
          //         //         'tax.percentage': get(data, 'tax.percentage'),
          //         //         currency: get(data, 'currency'),
          //         //         amount: get(data, 'valueAmount'),
          //         //       })
          //         //     )
          //         // }}
          //       />
          //     )}
          //     {/*<Link target={'_blank'} to={`/purchasing/order/${orderKey}/update`}>*/}
          //     {/*  <Icon style={{ marginLeft: 5 }} type="fullscreen" />*/}
          //     {/*</Link>*/}
          //   </Form.Item>
          // </Col>
        )}

        {isClaimTypeCreditCard && (
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Statement">
              {getFieldDecorator('statement._id', {
                initialValue: get(voucher, 'statement._id'),
                rules: rules.select,
              })(<StatementSelect keyAtr={'_id'} valueAtr={'display'} disabled={isConfirmed} />)}
            </Form.Item>
          </Col>
        )}
        {!isTransfer && (
          <>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Center">
              {getFieldDecorator('centers', {
                initialValue: get(voucher, 'centers'),
                rules: rules.select,
              })(
                <CentersCascader
                  key={isRequestFund ? getFieldValue('payee._id') : getFieldValue('company._id')}
                  company={isRequestFund ? getFieldValue('payee._id') : getFieldValue('company._id')}
                  // disabled={get(order, 'center._id')}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
          {!isNew && (
          <Col span={12}>
            <Form.Item {...boolLabelItemLayout} label={'Refresh Order lines'}>
              {getFieldDecorator('lineRefresh', {
                initialValue: false,
                valuePropName: 'checked',
              })(<Checkbox placeholder="lineRefresh" />)}
            </Form.Item>
          </Col>
            )}
          </>
        )}

      </Row>

      {!isClaimTypeCreditCard && !(isTransfer || isCreditCard || isRequestFund) && (
        <Row>
          <Taxes
            doc={voucher}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Purchase',
              hideRate: true,
            }}
          />
        </Row>
      )}

      {(isTaxInvoiceORCreditNoteOrNonTaxInvoice || isRequestFund) && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Claim Date">
              {getFieldDecorator('billDate', {
                initialValue: dateVal(voucher, 'billDate'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Invoice Date!',
                  },
                ],
              })(<DatePicker disabled={isConfirmed} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Due Date">
              {getFieldDecorator('dueDate', {
                initialValue: dateVal(voucher, 'dueDate'),
                rules: [
                  {
                    required: true,
                    message: 'Please Select a Due Date!',
                  },
                ],
              })(<DatePicker disabled={isConfirmed} style={{ width: '100%' }} placeholder="Due Date" />)}
            </Form.Item>
          </Col>
        </Row>
      )}

      {isClaimTypeCreditCard && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Lender Contract">
              {getFieldDecorator('lenderContract._id', {
                initialValue: get(voucher, 'lenderContract._id'),
                rules: rules.select,
              })(
                <LenderContractsSelect
                  keyAtr={'_id'}
                  valueAtr={'title'}
                  placeholder="Select a bank"
                  // disabled={!getFieldValue('payee._id') || isConfirmed}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Payment Plan Schedule">
              {getFieldDecorator('paymentPlan._id', {
                initialValue: get(voucher, 'paymentPlan._id'),
                rules: rules.select,
              })(
                <PayPlanSelect
                  keyAtr={'_id'}
                  valueAtr={'display'}
                  placeholder="Select a Payment Plan"
                  disabled={!getFieldValue('lenderContract._id') || isConfirmed}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      )}
      {!isTransfer && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Part Payment">
              {getFieldDecorator('isPercent', {
                initialValue: get(voucher, 'isPercent'),
                valuePropName: 'checked',
              })(<Checkbox disabled={isConfirmed} />)}
            </Form.Item>
          </Col>

          {getFieldValue('isPercent') && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Payment Percent">
                {getFieldDecorator('vPercent', {
                  initialValue: get(voucher, 'vPercent') || 30,
                })(
                  <Slider
                    defaultValue={get(voucher, 'vPercent') || 30}
                    step={0.001}
                    disabled={isConfirmed}
                    onChange={(e) => setVPercent(e)}
                    tooltipVisible
                    marks={{
                      0: 0,
                      20: 20,
                      40: 40,
                      60: 60,
                      80: 80,
                      100: 100,
                    }}
                  />
                )}
                <InputNumber
                  min={1}
                  max={100}
                  style={{ width: '50%' }}
                  value={vPercent}
                  onChange={(e) => setVPercent(e)}
                />
                <CustomModalButton
                  title="Set Payment Percent"
                  buttonName="Set Payment Percent"
                  loading={fetchingLines}
                  onSubmit={() => {
                    const newPercent = round((vPercent_Amount / vPercent_Total) * 100, 3)
                    setVPercent(newPercent)
                    setFieldsValue({
                      vPercent: newPercent,
                    })
                  }}>
                  <Form.Item {...defaultFormItemLayout} label="Total Amount">
                    <InputNumber value={vPercent_Total} onChange={(e) => setVPercent_Total(e)} />
                  </Form.Item>
                  <Form.Item {...defaultFormItemLayout} label="Partial Payment">
                    <InputNumber value={vPercent_Amount} onChange={(e) => setVPercent_Amount(e)} />
                  </Form.Item>
                </CustomModalButton>
              </Form.Item>
            </Col>
          )}
        </Row>
      )}

      <Row>
        {/*{orders && !isTransfer && (*/}
        {/*  <Col span={12}>*/}
        {/*    <Form.Item {...defaultFormItemLayout} label="Payment Plan Schedule">*/}
        {/*      {getFieldDecorator('paymentPlan._id', {*/}
        {/*        initialValue: get(voucher, 'paymentPlan._id'),*/}
        {/*        rules: rules.select,*/}
        {/*      })(*/}
        {/*        <PayPlanSelect*/}
        {/*          keyAtr={'_id'}*/}
        {/*          valueAtr={'display'}*/}
        {/*          placeholder="Select a Payment Plan"*/}
        {/*          disabled={!getFieldValue('orders') || isConfirmed}*/}
        {/*          style={{ width: '100%' }}*/}
        {/*        />*/}
        {/*      )}*/}
        {/*    </Form.Item>*/}
        {/*  </Col>*/}
        {/*)}*/}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Schedule Date">
            {getFieldDecorator('scheduledDate', {
              initialValue: dateVal(voucher, 'scheduledDate'),
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {!isClaimTypeCreditCard && !isTransfer && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Credit Card">
              {getFieldDecorator('isCreditCard', {
                initialValue: get(voucher, 'isCreditCard'),
                valuePropName: 'checked',
              })(<Checkbox disabled={isConfirmed} />)}
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Urgent">
            {getFieldDecorator('urgent', {
              initialValue: get(voucher, 'urgent'),
              valuePropName: 'checked',
            })(<Checkbox disabled={isConfirmed} />)}
          </Form.Item>
        </Col>
        {getFieldValue('urgent') && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Reason">
              {getFieldDecorator('reason', {
                initialValue: get(voucher, 'reason'),
              })(<Input disabled={isConfirmed} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        )}
      </Row>
      {!isClaimTypeCreditCard && !isTransfer && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Withhold Tax Applicable">
              {getFieldDecorator('wtax.applicable', {
                initialValue: get(voucher, 'wtax.applicable'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
          {iswtax && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Withhold tax">
                {getFieldDecorator('wtax.tax', {
                  initialValue: get(voucher, 'wtax.tax'),
                })(<InputNumber disabled={isConfirmed} style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
      <Row>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={<InfoTooltip value={'Voucher File'} title={'If empty; please upload files in documents tab.'} />}>
            {getFieldDecorator('file', {
              initialValue: get(voucher, 'file'),
            })(<FileSelectCmp keyAtr="_id" valueAtr="name" placeholder={'Voucher File'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Notify Rep">
            {getFieldDecorator('notify.main._id', {
              initialValue: get(voucher, 'notify.main._id'),
              rules: rules.select,
            })(<VendorRepSelect disabled={isConfirmed} keyAtr={'_id'} valueAtr={'name'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Notify Additional">
            {getFieldDecorator('notify.additional', {
              initialValue: get(voucher, 'notify.additional'),
            })(<Input disabled={isConfirmed} placestyle={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Remarks">
            {getFieldDecorator('remarks', {
              initialValue: get(voucher, 'remarks'),
              // rules: rules.input,
            })(<TextArea disabled={isConfirmed} rows={7} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

const TypeSelect = compose(
  withData({
    data: [
      {
        key: 'Account Transfer',
        value: 'Transfer - Account (Same Company & Bank)',
      },
      {
        key: 'Bank Transfer',
        value: 'Transfer - Bank (Same Company)',
      },
      {
        key: 'Funds Request',
        value: 'Funds Request / Inter-Company Transfer',
      },
      {
        key: 'Tax Invoice',
        value: 'Tax Invoice',
      },
      {
        key: 'Credit Note',
        value: 'Credit Note',
      },
      {
        key: 'Non Tax Invoice',
        value: 'Non Tax Invoice',
      },
      {
        key: 'Credit Card',
        value: 'Credit Card',
      },
    ],
  }),
  withSort
)(CustomSelect)

const VendorSelect = compose(
  withUrlFetch({
    name: 'members',
    url: `members/list/organisation`,
  }),
  withSpinning
)(CustomDebounceSelect)

export default Form.create()(VouchersForm)
